import Api from '@/services/Api'

export default {
  SendFeedback(feedback) {
    return Api().post('/feedback/', feedback);
  }
}
